import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Tyremaster = () => {
useAuthRedirect();
  const [data, setData] = useState([]);
   const [branches, setBranches] = useState([]);
  const storedBranch = localStorage.getItem("branch"); 
    const [selectedBranch, setSelectedBranch] = useState(storedBranch || ""); 
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  const canView  = hasPermission("Tyre Details", "view");
      const canEntry = hasPermission("Tyre Details", "entry");
      const canEdit  = hasPermission("Tyre Details", "edit");
      const canDel   = hasPermission("Tyre Details", "del");
    

  useEffect(() => {
  const fetchBranches = async () => {
    try {
      Swal.fire({
        title: "Loading Branches",
        html: `
          <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
            <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
          </div>
          <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch branch details...</p>
        `,
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          const style = document.createElement("style");
          style.innerHTML = `
            @keyframes progressBar {
              0% { width: 0% }
              50% { width: 100% }
              100% { width: 0% }
            }
          `;
          document.head.appendChild(style);
        },
      });

      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/main_details");
      setBranches(response.data.branches || []);

      Swal.close();
    } catch (error) {
      Swal.close();
      console.error("Error fetching branches:", error);
      Swal.fire({
        icon: "error",
        title: "Oops!",
        text: "Unable to load branch data. Please try again.",
      });
    }
  };

  {canView && (
  fetchBranches()
  )}
}, []);



  useEffect(() => {
    if (selectedBranch) {
  const fetchData = async () => {
    setLoading(true);
    try {
    //   const response = await axios.get("https://rfs2.infraconsoft.net.in/api/vehicle_typemaster_api");

        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/get_tyre_master_api?branch_code=${selectedBranch}`);
 

      console.log("API Response:", response.data.vehicles);
      setData(response.data.vehicles);
      setFilteredData(response.data.vehicles);
    } catch (error) {
      console.error("Error fetching vehicles:", error);
    } finally {
      setLoading(false);
    }
  };
  fetchData();
}
}, [selectedBranch]);

const handleCheckboxChange = (id) => {
    const numericId = Number(id); // ensure numeric
    setSelectedIds((prev) =>
      prev.includes(numericId)
        ? prev.filter((i) => i !== numericId)
        : [...prev, numericId]
    );
  };
    

  const handleBulkDelete = () => {
    if (selectedIds.length === 0) {
      Swal.fire("Warning", "No items selected for deletion.", "warning");
      return;
    }
  
    console.log("Selected IDs to delete:", selectedIds);
  
    Swal.fire({
      title: `Delete ${selectedIds.length} item(s)?`,
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete them!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const deleteRequests = selectedIds.map((id) => {
            console.log(`Sending DELETE request for ID: ${id}`);
            return axios.delete(`https://rfs2.infraconsoft.net.in/api/tyre_master_delete/${id}`);
          });
  
          await Promise.all(deleteRequests);
  
          // Remove from UI
          const updatedData = data.filter((item) => !selectedIds.includes(item.tyre_id));
          setData(updatedData);
          setFilteredData(updatedData);
          setSelectedIds([]);
  
          Swal.fire("Deleted!", "Selected records have been deleted.", "success");
          window.location.reload();
        } catch (error) {
          console.error("Bulk delete error:", error);
          if (error.response) {
            console.error("Server response:", error.response.data);
          }
          Swal.fire("Error", "Failed to delete selected records.", "error");
        }
      }
    });
  };

 
  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (term === "") {
      setFilteredData(data);
      return;
    }
  
    const filtered = data.filter((item) =>
      (String(item.tyre_seriolno || "").toLowerCase().includes(term) ||
    String(item.tyre_model || "").toLowerCase().includes(term))
    );
  
    setFilteredData(filtered);
  };
  


  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Tyre Listing</h2>
          <Time />
        </section>

       
    <div className="vehicle-class">
  <div>
    <p>Branch wise Report :</p>
        <select 
          value={selectedBranch} 
          onChange={(e) => setSelectedBranch(e.target.value)} 
          required 
          className="branch-select"
        >
          <option value="">Select Branch</option>
          {branches.map((item) => (
            <option key={item.branchMaster_code} value={item.branchMaster_code}>
              {item.branchMaster_name}
            </option>
          ))}
        </select>
  </div>
  </div>


        {/* Add New Button */}
        {canEntry && (
        <div className="add-new-container">
          <Link to={`/add_tyre`}>
            <button className="add-new-btn">
              <i className="fa-solid fa-plus"></i> Add New
            </button>
          </Link>
        </div>
        )}

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by Tyre Code & Model"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
            <tr>
            <th>S.No</th>
            <th>Tyre Code</th>
            <th>Tyre Model</th>
            <th>Tyre Amount</th>
            <th>Tyre Type</th>
            {canView && (
            <th>View</th>
            )}
            {canEdit && (
            <th>Edit</th>
            )}
            {canDel && (
                <th>
                <button onClick={handleBulkDelete} className="btn btn-danger btn-sm ms-2">
        Delete
      </button>
                </th>
            )}
               
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                          <td>{indexOfFirstItem + index + 1}</td>
                   <td>{item.tyre_seriolno}</td>                    
                    <td>{item.tyre_model}</td>                    
                    <td>{item.tyre_amount}</td>                    
                    <td>{item.tyre_type}</td>    
                    {canView && (
                    <td>
                      <Link to={`/view_tyre/${item.tyre_id}`}>View</Link>
                    </td>
                    )}
                    {canEdit && (
                    <td>
                      <Link to={`/edit_tyre/${item.tyre_id}`}>Edit</Link>
                    </td>
                    )}
                    {canDel && (
                    <td>
              <input
                type="checkbox"
                checked={selectedIds.includes(Number(item.tyre_id))}
                onChange={() => handleCheckboxChange(item.tyre_id)}
              />
            </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Tyremaster;
